























import Vue from "vue";
export default Vue.extend({
	props: ["data"],

	methods: {
		handleOk(bvModalEvt: any) {
			bvModalEvt.preventDefault();
			this.handleSubmit();
		},
		handleSubmit() {
			this.$emit("primarysubmit", this.data);
			this.$nextTick(() => {
				this.$bvModal.hide("skills-info");
			});
		},
		hideModal() {
			this.$bvModal.hide("skills-info");
		},
	},
});
